import React, { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const InvoiceSendDialog = ({ inv, sending, onClose, onSend }) => {
  const [msg, setMsg] = useState("");
  useEffect(() => { setMsg(""); }, [inv?.booking_id]);
  return (
    <Dialog open={!!inv} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="invoice-send-dialog" className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Rechnung {inv?.invoice_no} senden</DialogTitle>
          <DialogDescription>An {inv?.email} · {inv?.total?.toFixed(2)} CHF</DialogDescription>
        </DialogHeader>
        <label className="text-sm font-medium text-slate-700">Persönliche Nachricht (optional)</label>
        <textarea
          data-testid="invoice-send-message"
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          rows={5}
          maxLength={3000}
          placeholder="z. B. Vielen Dank, dass Sie sich für MyCleaner entschieden haben…"
          className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500/30"
        />
        <p className="text-xs text-slate-400">Der Text erscheint in der E-Mail über der Rechnungsübersicht.</p>
        <div className="flex justify-end gap-2 pt-2">
          <button data-testid="invoice-send-cancel" onClick={onClose} className="px-4 h-10 rounded-xl text-sm font-semibold text-slate-600 hover:bg-slate-100">Abbrechen</button>
          <button data-testid="invoice-send-confirm" disabled={sending} onClick={() => onSend(msg)} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-xl bg-teal-700 text-white text-sm font-semibold hover:bg-teal-800 disabled:opacity-50">
            <Send className="w-4 h-4" /> {sending ? "Sende…" : "Jetzt senden"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
